import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import About from "@/pages/About";
import Process from "@/pages/Process";
import Contact from "@/pages/Contact";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const useJsonLd = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "GeneralContractor",
      name: "Sandquist Construction",
      url: window.location.origin,
      telephone: "(510) 604-1250",
      address: {
        "@type": "PostalAddress",
        streetAddress: "1172 San Pablo Avenue, Suite 200C",
        addressLocality: "Berkeley",
        addressRegion: "CA",
        postalCode: "94706",
        addressCountry: "US",
      },
      areaServed: ["Berkeley", "Oakland", "East Bay"],
      founder: { "@type": "Person", name: "Rick Sandquist" },
      description:
        "General contractor building custom homes and remodels in Berkeley, Oakland, and the greater East Bay. CA License #572537, licensed since 1989.",
    });
    document.head.appendChild(script);
    return () => script.remove();
  }, []);
};

function App() {
  useJsonLd();
  return (
    <div className="min-h-screen bg-canvas text-ink font-body">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/process" element={<Process />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
